// extracted by mini-css-extract-plugin
export default {"officeInfoMenus":"styles_officeInfoMenus__r24YP"};